/* =====================================================================
   21 MARS — Méga-menu modèles (custom)
   Transforme les entrées "Les hauts" et "Les bas" du menu en vitrine
   à vignettes (photo + nom + descriptif + tag), desktop ET mobile.
   Source de données = celle du calculateur (mêmes mots partout).

   → À déposer dans Assets, puis charger dans le thème (voir la fiche
     process). Rien à changer dans le rendu : tout est piloté par le
     bloc CONFIG ci-dessous.
   ===================================================================== */
(function () {
  'use strict';

  /* ======================= CONFIG (à ajuster) ======================= */

  // Intitulés EXACTS des entrées de menu à transformer.
  // Doivent correspondre au texte saisi dans Shopify → Navigation.
  var TRIGGERS = { 'les hauts': 'hauts', 'les bas': 'bas' };

  // Largeur (px) au-dessus de laquelle on affiche le méga-menu déroulant
  // (desktop). En dessous : accordéon dans le menu mobile.
  var DESKTOP_MIN = 1000;

  // Desktop : false = on garde le méga-menu NATIF du thème (recommandé — tu l'utilises déjà
  // sur E-Shop). true = le méga-menu custom prend aussi le desktop. Ici le custom sert le MOBILE.
  var HOOK_DESKTOP = false;

  // Chips par catégorie. ⚠️ REMPLACE les URLs par tes vraies collections
  // (copie le handle exact depuis Shopify).
  var CHIPS = {
    hauts: [
      { label: '1ère brassière', url: '/pages/premier-soutien-gorge' },
      { label: 'Brassières',     url: '/collections/brassieres' },
      { label: 'Soutiens-gorge', url: '/collections/soutiens-gorge' },
      { label: 'Bandeaux',       url: '/collections/bandeaux' },
      { label: 'Petit Dos',      url: '/collections/petit-dos' }
    ],
    bas: [
      { label: 'Culottes', url: '/collections/culottes' },
      { label: 'Shortys',  url: '/collections/shortys' }
    ]
  };

  // Ordre des vignettes par groupe.
  var GROUPES = {
    hauts: ['Garance','Céleste', 'Suzane', 'Joe','Nell','Romane','Caliste','Jade'],
    bas:   ['Margot', 'Adèle', 'Louise']
  };

  var HUB_URL    = '/pages/bien-choisir-son-modele'; // hub "Tous nos modèles"
  var TAILLE_URL = '/pages/guide-des-tailles-1';      // le calculateur

  /* =============== DONNÉES MODÈLES (= calculateur) =============== */

  var CDN = 'https://cdn.shopify.com/s/files/1/0894/9917/3187/files/';
  var IMG = '&width=400&height=400&crop=center';
  var META = {
    'Garance': { desc: 'Brassière · Sans armature, toutes morphologies',        url: '/collections/brassiere-garance',             img: CDN + 'GARANCE_NUDE_FACE.jpg?v=1769784166' + IMG, fit: 'epaules' },
    'Suzane':  { desc: 'Brassière · Réversible 4-en-1',                          url: '/collections/brassiere-suzane',              img: CDN + 'SUZANE_BLANC_FACE-ROND.jpg?v=1770312879' + IMG },
    'Céleste': { desc: 'Triangle · Premier soutien-gorge, sans armature',        url: '/collections/soutien-gorge-triangle-celeste', img: CDN + 'CELESTE_BLANC_FACE.jpg?v=1770370813' + IMG, fit: 'dos' },
    'Joe':     { desc: 'Brassière · Dos et épaules réglables, morphologies menues', url: '/collections/brassiere-joe',              img: CDN + 'JOE_NUDE_FACE.jpg?v=1774972637' + IMG, fit: 'dos' },
    'Caliste': { desc: 'Bandeau · Sans bretelles, invisible',                    url: '/collections/soutien-gorge-bandeau-caliste', img: CDN + 'CALISTE_CORAIL_FACE.jpg?v=1770374795' + IMG },
    'Jade':    { desc: 'Brassière · Maintien doux, poitrines développées',       url: '/collections/brassiere-jade',                img: CDN + 'JADE_NUDE_FACE.jpg?v=1770299766' + IMG },
    'Nell':    { desc: 'Cache-cœur · Maintien renforcé, tailles spécifiques petit dos',     url: '/collections/brassiere-cache-coeur-nell',    img: CDN + 'NELL_MARINE_FACE1.jpg?v=1774980155' + IMG, fit: 'dos' },
    'Romane':  { desc: 'Triangle · Fantaisie, sans armature',                    url: '/collections/soutien-gorge-triangle-romane', img: CDN + 'ROMANE_NOIR_FACE_866331e8-104f-4b55-aad2-469b163c21fd.jpg?v=1770300432' + IMG, fit: 'dos' },
    'Margot':  { desc: 'Culotte · Coupe intemporelle, coton bio',                url: '/collections/culotte-margot',                img: CDN + 'MARGOT_NUDE_FACE.jpg?v=1770382854' + IMG },
    'Adèle':   { desc: 'Shorty · Invisible, sans élastique',                     url: '/collections/shorty-adele',                  img: CDN + 'ADELE_BLANC_FACE.jpg?v=1770302371' + IMG },
    'Louise':  { desc: 'Culotte · Fantaisie, coton bio',                         url: '/collections/culotte-louise',                img: CDN + 'LOUISE_NOIR_FACE.jpg?v=1770311047' + IMG }
  };
  var FIT_LABEL = { dos: 'Dos & bretelles réglables', epaules: 'Bretelles réglables' };

  /* ========================== RENDU ========================== */

  function vignette(nom) {
    var m = META[nom];
    if (!m) return '';
    var badge = m.fit ? '<span class="mm-fit">' + FIT_LABEL[m.fit] + '</span>' : '';
    return '<a class="mm-vig" href="' + m.url + '">'
      + '<span class="mm-thumb"><img src="' + m.img + '" alt="' + nom + '" loading="lazy"></span>'
      + '<span class="mm-nom">' + nom + '</span>'
      + '<span class="mm-desc">' + m.desc + '</span>'
      + badge + '</a>';
  }

  function panelInner(groupe) {
    var chips = (CHIPS[groupe] || []).map(function (c) {
      return '<a class="mm-chip" href="' + c.url + '">' + c.label + '</a>';
    }).join('');
    var vigs = (GROUPES[groupe] || []).map(vignette).join('');
    return '<div class="mm-inner">'
      + (chips ? '<p class="mm-label">Par famille</p><div class="mm-chips">' + chips + '</div>' : '')
      + '<p class="mm-label">Nos modèles — Fais défiler</p><div class="mm-grid">' + vigs + '</div>'
      + '<div class="mm-links">'
      + '<a class="mm-all" href="' + HUB_URL + '">Voir tous nos modèles →</a>'
      + '<a class="mm-sec" href="' + TAILLE_URL + '">Trouver ma taille</a>'
      + '</div></div>';
  }

  /* ==================== COMPORTEMENT ==================== */

  function isDesktop() { return window.innerWidth >= DESKTOP_MIN; }

  // Panneau desktop partagé (un seul, positionné sous l'entrée survolée).
  var deskPanel = null, deskCurrent = null, hideTimer = null;

  function ensureDeskPanel() {
    if (deskPanel) return deskPanel;
    deskPanel = document.createElement('div');
    deskPanel.className = 'mm-desktop';
    deskPanel.setAttribute('role', 'region');
    document.body.appendChild(deskPanel);
    deskPanel.addEventListener('mouseenter', function () { clearTimeout(hideTimer); });
    deskPanel.addEventListener('mouseleave', hideDeskSoon);
    return deskPanel;
  }

  function showDesk(anchor, groupe) {
    var p = ensureDeskPanel();
    if (deskCurrent !== groupe) { p.innerHTML = panelInner(groupe); deskCurrent = groupe; }
    var r = anchor.getBoundingClientRect();
    p.style.top = (r.bottom + window.scrollY) + 'px';
    p.classList.add('mm-open');
    clearTimeout(hideTimer);
  }
  function hideDeskSoon() { hideTimer = setTimeout(function () { if (deskPanel) deskPanel.classList.remove('mm-open'); }, 180); }

  // Panneau mobile inline (inséré après l'entrée, dans le menu hamburger).
  function toggleMobile(anchor, groupe) {
    var host = anchor.closest('li') || anchor.parentNode;
    var next = host.nextElementSibling;
    if (next && next.classList && next.classList.contains('mm-mobile')) {
      var open = next.classList.toggle('mm-open');
      anchor.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    var panel = document.createElement('li');
    panel.className = 'mm-mobile mm-open';
    panel.innerHTML = panelInner(groupe);
    host.parentNode.insertBefore(panel, host.nextSibling);
    anchor.setAttribute('aria-expanded', 'true');
  }

  function bindTrigger(anchor, groupe) {
    if (anchor.dataset.mmInit) return;
    anchor.dataset.mmInit = '1';
    anchor.setAttribute('aria-haspopup', 'true');

    // Desktop : seulement si HOOK_DESKTOP (sinon on laisse le méga-menu NATIF du thème)
    if (HOOK_DESKTOP) {
      var li = anchor.closest('li') || anchor;
      li.addEventListener('mouseenter', function () { if (isDesktop()) showDesk(anchor, groupe); });
      li.addEventListener('mouseleave', function () { if (isDesktop()) hideDeskSoon(); });
      anchor.addEventListener('focus', function () { if (isDesktop()) showDesk(anchor, groupe); });
    }

    // Clic : mobile → accordéon vignettes ; desktop → laisse passer (méga-menu natif)
    anchor.addEventListener('click', function (e) {
      if (!isDesktop()) { e.preventDefault(); e.stopPropagation(); toggleMobile(anchor, groupe); }
    });
  }

  function scan() {
    var links = document.querySelectorAll('a');
    for (var i = 0; i < links.length; i++) {
      var t = (links[i].textContent || '').trim().toLowerCase();
      if (TRIGGERS.hasOwnProperty(t)) bindTrigger(links[i], TRIGGERS[t]);
    }
  }

  // Fermetures globales
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && deskPanel) deskPanel.classList.remove('mm-open'); });
  window.addEventListener('scroll', function () { if (deskPanel && deskPanel.classList.contains('mm-open')) deskPanel.classList.remove('mm-open'); }, { passive: true });

  function init() {
    scan();
    // Les menus (surtout mobile) sont parfois injectés après coup : on re-scanne.
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();